import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2331 2331"
      id="vector">
      <g
        id="group"
        transform="translate(232 151)">
        <path
          id="path"
          d="M 1073.5 0 L 1717 0.5 L 1073.5 1 L 1073.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 1724.5 0 L 1732 0.5 L 1724.5 1 L 1724.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 1059.5 1 L 1064 1.5 L 1059.5 2 L 1059.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 1740.5 1 L 1744 1.5 L 1740.5 2 L 1740.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 1051.5 2 L 1055 2.5 L 1051.5 3 L 1051.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 1748.5 2 L 1751 2.5 L 1748.5 3 L 1748.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 1797.5 19 L 1798.5 21 L 1797.5 19 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 996.5 21 L 995.5 23 L 996.5 21 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 1809.5 27 L 1810.5 29 L 1809.5 27 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 1813.5 30 L 1815.5 33 L 1813.5 30 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 979.5 32 L 978.5 34 L 979.5 32 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 1818.5 34 L 1833.5 50 L 1818.5 34 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 975.5 35 L 974.5 37 L 975.5 35 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 971.5 38 L 968.5 42 L 971.5 38 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 964.5 44 L 954.5 55 L 964.5 44 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 1835.5 52 L 1837.5 55 L 1835.5 52 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 1839.5 57 L 1840.5 59 L 1839.5 57 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 951.5 58 L 948.5 62 L 951.5 58 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 946.5 64 L 944.5 67 L 946.5 64 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 942.5 69 L 941.5 71 L 942.5 69 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 1074.5 70 L 1587 70.5 L 1074.5 71 L 1074.5 70 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 1725.5 70 L 1729 70.5 L 1725.5 71 L 1725.5 70 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 1064.5 71 L 1067 71.5 L 1064.5 72 L 1064.5 71 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1715.5 71 L 1718 71.5 L 1715.5 72 L 1715.5 71 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 1735.5 71 L 1739 71.5 L 1735.5 72 L 1735.5 71 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 940.5 72 L 939.5 74 L 940.5 72 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 1058.5 72 L 1061 72.5 L 1058.5 73 L 1058.5 72 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 1710.5 72 L 1713 72.5 L 1710.5 73 L 1710.5 72 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 1689.5 81 L 1688.5 83 L 1689.5 81 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 1686.5 83 L 1685.5 85 L 1686.5 83 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 1768.5 84 L 1769.5 86 L 1768.5 84 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 1024.5 86 L 1023.5 88 L 1024.5 86 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 1682.5 86 L 1672.5 97 L 1682.5 86 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 1772.5 87 L 1780.5 96 L 1772.5 87 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 1021.5 88 L 1020.5 90 L 1021.5 88 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 1017.5 91 L 1014.5 95 L 1017.5 91 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 1010.5 97 L 1007.5 101 L 1010.5 97 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 1782.5 98 L 1783.5 100 L 1782.5 98 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 1670.5 99 L 1669.5 101 L 1670.5 99 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 1668.5 102 L 1667.5 104 L 1668.5 102 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 1786.5 104 L 1787.5 106 L 1786.5 104 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 1003.5 105 L 1001.5 108 L 1003.5 105 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 1863.5 108 L 1864 110.5 L 1863 110.5 L 1863.5 108 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 999.5 110 L 998.5 112 L 999.5 110 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 1864.5 113 L 1865 115.5 L 1864 115.5 L 1864.5 113 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 1865.5 119 L 1866 121.5 L 1865 121.5 L 1865.5 119 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 1866.5 126 L 1867 132.5 L 1866 132.5 L 1866.5 126 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 1657.5 130 L 1658 133.5 L 1657 133.5 L 1657.5 130 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 1796.5 131 L 1797 135.5 L 1796 135.5 L 1796.5 131 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 913.5 133 L 914 135.5 L 913 135.5 L 913.5 133 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 912.5 139 L 913 141.5 L 912 141.5 L 912.5 139 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 911.5 145 L 912 148.5 L 911 148.5 L 911.5 145 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 982.5 146 L 983 148.5 L 982 148.5 L 982.5 146 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 981.5 151 L 982 153.5 L 981 153.5 L 981.5 151 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 910.5 154 L 911 162.5 L 910 162.5 L 910.5 154 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 980.5 158 L 981 165.5 L 980 165.5 L 980.5 158 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 1657.5 280 L 1797 280.5 L 1657.5 281 L 1657.5 280 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 1657.5 350 L 1867 350.5 L 1657.5 351 L 1657.5 350 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 416.5 490 L 681 490.5 L 416.5 491 L 416.5 490 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 408.5 491 L 411 491.5 L 408.5 492 L 408.5 491 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 686.5 491 L 689 491.5 L 686.5 492 L 686.5 491 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 716.5 500 L 717.5 502 L 716.5 500 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 378.5 501 L 377.5 503 L 378.5 501 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 373.5 504 L 372.5 506 L 373.5 504 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 723.5 504 L 724.5 506 L 723.5 504 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 726.5 506 L 727.5 508 L 726.5 506 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 367.5 508 L 366.5 510 L 367.5 508 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 729.5 508 L 730.5 510 L 729.5 508 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 363.5 511 L 361.5 514 L 363.5 511 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 733.5 511 L 736.5 515 L 733.5 511 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 356.5 517 L 353.5 521 L 356.5 517 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 741.5 518 L 742.5 520 L 741.5 518 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 350.5 524 L 347.5 528 L 350.5 524 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 746.5 524 L 748.5 527 L 746.5 524 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 750.5 529 L 751.5 531 L 750.5 529 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 345.5 530 L 344.5 532 L 345.5 530 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 343.5 533 L 342.5 535 L 343.5 533 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 756.5 538 L 757.5 540 L 756.5 538 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 420.5 560 L 677 560.5 L 420.5 561 L 420.5 560 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 685.5 563 L 686.5 565 L 685.5 563 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 408.5 565 L 407.5 567 L 408.5 565 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 688.5 565 L 689.5 567 L 688.5 565 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 328.5 568 L 329 570.5 L 328 570.5 L 328.5 568 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 402.5 571 L 401.5 573 L 402.5 571 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 694.5 571 L 695.5 573 L 694.5 571 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 327.5 574 L 328 577.5 L 327 577.5 L 327.5 574 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 769.5 575 L 770 578.5 L 769 578.5 L 769.5 575 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 319.5 607 L 327 607.5 L 319.5 608 L 319.5 607 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 770.5 607 L 910 607.5 L 770.5 608 L 770.5 607 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 1657.5 607 L 1759 607.5 L 1657.5 608 L 1657.5 607 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 310.5 608 L 313 608.5 L 310.5 609 L 310.5 608 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 1764.5 608 L 1768 608.5 L 1764.5 609 L 1764.5 608 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 304.5 609 L 307 609.5 L 304.5 610 L 304.5 609 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 299.5 610 L 302 610.5 L 299.5 611 L 299.5 610 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 267.5 623 L 266.5 625 L 267.5 623 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 1809.5 623 L 1810.5 625 L 1809.5 623 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 261.5 627 L 260.5 629 L 261.5 627 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 258.5 629 L 257.5 631 L 258.5 629 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 1818.5 629 L 1819.5 631 L 1818.5 629 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 254.5 632 L 252.5 635 L 254.5 632 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 1822.5 632 L 1824.5 635 L 1822.5 632 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 248.5 637 L 240.5 646 L 248.5 637 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 1828.5 637 L 1837.5 647 L 1828.5 637 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 237.5 649 L 235.5 652 L 237.5 649 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 1839.5 649 L 1842.5 653 L 1839.5 649 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 233.5 654 L 232.5 656 L 233.5 654 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 1843.5 654 L 1844.5 656 L 1843.5 654 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 1846.5 658 L 1847.5 660 L 1846.5 658 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 224.5 668 L 223.5 670 L 224.5 668 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 322.5 677 L 327 677.5 L 322.5 678 L 322.5 677 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 770.5 677 L 910 677.5 L 770.5 678 L 770.5 677 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 1657.5 677 L 1755 677.5 L 1657.5 678 L 1657.5 677 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 316.5 678 L 319 678.5 L 316.5 679 L 316.5 678 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 1758.5 678 L 1761 678.5 L 1758.5 679 L 1758.5 678 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 299.5 686 L 298.5 688 L 299.5 686 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 1777.5 686 L 1778.5 688 L 1777.5 686 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 1781.5 689 L 1784.5 693 L 1781.5 689 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 294.5 690 L 292.5 693 L 294.5 690 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 290.5 695 L 288.5 698 L 290.5 695 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 1787.5 696 L 1788.5 698 L 1787.5 696 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 212.5 699 L 213 701.5 L 212 701.5 L 212.5 699 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 1789.5 699 L 1790.5 701 L 1789.5 699 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 1864.5 699 L 1865 701.5 L 1864 701.5 L 1864.5 699 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 211.5 704 L 212 707.5 L 211 707.5 L 211.5 704 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 1865.5 704 L 1866 706.5 L 1865 706.5 L 1865.5 704 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 1866.5 711 L 1867 716.5 L 1866 716.5 L 1866.5 711 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 210.5 712 L 211 717.5 L 210 717.5 L 210.5 712 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 280.5 717 L 281 720.5 L 280 720.5 L 280.5 717 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 1796.5 717 L 1797 719.5 L 1796 719.5 L 1796.5 717 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 840.5 770 L 910 770.5 L 840.5 771 L 840.5 770 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 1657.5 770 L 1727 770.5 L 1657.5 771 L 1657.5 770 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 110.5 1027 L 210 1027.5 L 110.5 1028 L 110.5 1027 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 100.5 1028 L 104 1028.5 L 100.5 1029 L 100.5 1028 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 94.5 1029 L 97 1029.5 L 94.5 1030 L 94.5 1029 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 54.5 1045 L 53.5 1047 L 54.5 1045 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 51.5 1047 L 50.5 1049 L 51.5 1047 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 48.5 1049 L 47.5 1051 L 48.5 1049 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 44.5 1052 L 42.5 1055 L 44.5 1052 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 38.5 1057 L 29.5 1067 L 38.5 1057 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 26.5 1070 L 24.5 1073 L 26.5 1070 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 22.5 1075 L 21.5 1077 L 22.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 20.5 1078 L 19.5 1080 L 20.5 1078 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 18.5 1081 L 17.5 1083 L 18.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 113.5 1097 L 210 1097.5 L 113.5 1098 L 113.5 1097 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 1027.5 1097 L 1517 1097.5 L 1027.5 1098 L 1027.5 1097 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 89.5 1106 L 88.5 1108 L 89.5 1106 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 85.5 1109 L 81.5 1114 L 85.5 1109 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 79.5 1116 L 78.5 1118 L 79.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 77.5 1119 L 76.5 1121 L 77.5 1119 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 1.5 1124 L 2 1126.5 L 1 1126.5 L 1.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 0.5 1131 L 1 1136.5 L 0 1136.5 L 0.5 1131 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 70.5 1136 L 71 1139.5 L 70 1139.5 L 70.5 1136 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 957.5 1167 L 1587 1167.5 L 957.5 1168 L 957.5 1167 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 1353.5 1214 L 1354 1283.5 L 1353 1283.5 L 1353.5 1214 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 1423.5 1214 L 1424 1283.5 L 1423 1283.5 L 1423.5 1214 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 1353.5 1354 L 1354 1423.5 L 1353 1423.5 L 1353.5 1354 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 1423.5 1354 L 1424 1423.5 L 1423 1423.5 L 1423.5 1354 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 1353.5 1494 L 1354 1563.5 L 1353 1563.5 L 1353.5 1494 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 1423.5 1494 L 1424 1563.5 L 1423 1563.5 L 1423.5 1494 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 699.5 1564 L 700 1566.5 L 699 1566.5 L 699.5 1564 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 769.5 1569 L 770 1572.5 L 769 1572.5 L 769.5 1569 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 327.5 1570 L 328 1573.5 L 327 1573.5 L 327.5 1570 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 401.5 1575 L 403.5 1578 L 401.5 1575 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 695.5 1575 L 688.5 1583 L 695.5 1575 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 328.5 1577 L 329 1579.5 L 328 1579.5 L 328.5 1577 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 406.5 1580 L 408.5 1583 L 406.5 1580 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 421.5 1587 L 676 1587.5 L 421.5 1588 L 421.5 1587 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 757.5 1608 L 756.5 1610 L 757.5 1608 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 345.5 1617 L 346.5 1619 L 345.5 1617 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 751.5 1617 L 750.5 1619 L 751.5 1617 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 348.5 1621 L 350.5 1624 L 348.5 1621 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 748.5 1621 L 745.5 1625 L 748.5 1621 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 737.5 1632 L 734.5 1636 L 737.5 1632 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 360.5 1633 L 363.5 1637 L 360.5 1633 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 1353.5 1634 L 1354 1703.5 L 1353 1703.5 L 1353.5 1634 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 731.5 1637 L 730.5 1639 L 731.5 1637 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 366.5 1638 L 367.5 1640 L 366.5 1638 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 369.5 1640 L 370.5 1642 L 369.5 1640 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 727.5 1640 L 726.5 1642 L 727.5 1640 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 372.5 1642 L 373.5 1644 L 372.5 1642 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 691.5 1655 L 694 1655.5 L 691.5 1656 L 691.5 1655 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 408.5 1656 L 412 1656.5 L 408.5 1657 L 408.5 1656 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 685.5 1656 L 689 1656.5 L 685.5 1657 L 685.5 1656 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 416.5 1657 L 537 1657.5 L 416.5 1658 L 416.5 1657 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 607.5 1657 L 680 1657.5 L 607.5 1658 L 607.5 1657 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 280.5 1754 L 281 1757.5 L 280 1757.5 L 280.5 1754 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 1796.5 1754 L 1797 1757.5 L 1796 1757.5 L 1796.5 1754 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 210.5 1757 L 211 1762.5 L 210 1762.5 L 210.5 1757 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 1866.5 1758 L 1867 1763.5 L 1866 1763.5 L 1866.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 211.5 1767 L 212 1769.5 L 211 1769.5 L 211.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 1865.5 1768 L 1866 1770.5 L 1865 1770.5 L 1865.5 1768 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 212.5 1773 L 213 1775.5 L 212 1775.5 L 212.5 1773 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 1864.5 1773 L 1865 1775.5 L 1864 1775.5 L 1864.5 1773 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 288.5 1777 L 289.5 1779 L 288.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 1788.5 1777 L 1787.5 1779 L 1788.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 292.5 1782 L 295.5 1786 L 292.5 1782 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 1784.5 1782 L 1781.5 1786 L 1784.5 1782 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 298.5 1787 L 299.5 1789 L 298.5 1787 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 1778.5 1787 L 1777.5 1789 L 1778.5 1787 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 316.5 1796 L 319 1796.5 L 316.5 1797 L 316.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 1758.5 1796 L 1761 1796.5 L 1758.5 1797 L 1758.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 322.5 1797 L 537 1797.5 L 322.5 1798 L 322.5 1797 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 607.5 1797 L 1755 1797.5 L 607.5 1798 L 607.5 1797 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 223.5 1805 L 224.5 1807 L 223.5 1805 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 1849.5 1812 L 1848.5 1814 L 1849.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 229.5 1815 L 230.5 1817 L 229.5 1815 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 1847.5 1815 L 1846.5 1817 L 1847.5 1815 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 1845.5 1818 L 1843.5 1821 L 1845.5 1818 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 232.5 1819 L 233.5 1821 L 232.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 1842.5 1822 L 1840.5 1825 L 1842.5 1822 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 235.5 1823 L 237.5 1826 L 235.5 1823 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 239.5 1828 L 248.5 1838 L 239.5 1828 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 1837.5 1828 L 1827.5 1839 L 1837.5 1828 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 252.5 1840 L 254.5 1843 L 252.5 1840 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 1824.5 1840 L 1822.5 1843 L 1824.5 1840 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 257.5 1844 L 258.5 1846 L 257.5 1844 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 1819.5 1844 L 1818.5 1846 L 1819.5 1844 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 266.5 1850 L 267.5 1852 L 266.5 1850 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 1810.5 1850 L 1809.5 1852 L 1810.5 1850 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 309.5 1866 L 313 1866.5 L 309.5 1867 L 309.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 1764.5 1866 L 1768 1866.5 L 1764.5 1867 L 1764.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 318.5 1867 L 537 1867.5 L 318.5 1868 L 318.5 1867 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 607.5 1867 L 1759 1867.5 L 607.5 1868 L 607.5 1867 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 536.5 1917 L 537 1920.5 L 536 1920.5 L 536.5 1917 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 70.5 1918 L 71 1921.5 L 70 1921.5 L 70.5 1918 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 606.5 1918 L 607 1925.5 L 606 1925.5 L 606.5 1918 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 0.5 1922 L 1 1927.5 L 0 1927.5 L 0.5 1922 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 605.5 1930 L 606 1933.5 L 605 1933.5 L 605.5 1930 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 1.5 1932 L 2 1934.5 L 1 1934.5 L 1.5 1932 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 2.5 1937 L 3 1939.5 L 2 1939.5 L 2.5 1937 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 77.5 1939 L 78.5 1941 L 77.5 1939 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 80.5 1943 L 87.5 1951 L 80.5 1943 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 526.5 1943 L 520.5 1950 L 526.5 1943 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 517.5 1951 L 516.5 1953 L 517.5 1951 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 514.5 1953 L 513.5 1955 L 514.5 1953 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 110.5 1960 L 114 1960.5 L 110.5 1961 L 110.5 1960 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 493.5 1960 L 497 1960.5 L 493.5 1961 L 493.5 1960 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 591.5 1972 L 590.5 1974 L 591.5 1972 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 18.5 1977 L 19.5 1979 L 18.5 1977 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 20.5 1980 L 21.5 1982 L 20.5 1980 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 585.5 1981 L 584.5 1983 L 585.5 1981 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 23.5 1984 L 24.5 1986 L 23.5 1984 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 582.5 1985 L 581.5 1987 L 582.5 1985 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 26.5 1988 L 32.5 1995 L 26.5 1988 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 578.5 1990 L 566.5 2003 L 578.5 1990 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 36.5 1998 L 41.5 2004 L 36.5 1998 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 563.5 2004 L 561.5 2007 L 563.5 2004 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 44.5 2005 L 46.5 2008 L 44.5 2005 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 48.5 2008 L 49.5 2010 L 48.5 2008 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 558.5 2008 L 557.5 2010 L 558.5 2008 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 555.5 2010 L 554.5 2012 L 555.5 2010 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 552.5 2012 L 551.5 2014 L 552.5 2012 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 92.5 2028 L 95 2028.5 L 92.5 2029 L 92.5 2028 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 98.5 2029 L 101 2029.5 L 98.5 2030 L 98.5 2029 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 506.5 2029 L 509 2029.5 L 506.5 2030 L 506.5 2029 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 105.5 2030 L 111 2030.5 L 105.5 2031 L 105.5 2030 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 496.5 2030 L 502 2030.5 L 496.5 2031 L 496.5 2030 Z"
          fill="currentColor"
          fillOpacity="0.6392157"
          stroke="currentColor"
          strokeOpacity="0.6392157"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 1064.5 1 L 1739.5 1 L 1769.5 7 L 1796.5 19 Q 1818.9 32.1 1835 51.5 Q 1847 65.5 1855 83.5 L 1863 106.5 L 1866 122.5 L 1866 132.5 L 1867 133.5 L 1867 350 L 1657 350 L 1657 608 L 1763.5 608 L 1764.5 609 L 1775.5 610 Q 1816 620.5 1839 648.5 Q 1849.7 660.8 1857 676.5 L 1864 697.5 L 1866 707.5 L 1866 716.5 L 1867 717.5 L 1867 1757.5 L 1866 1758.5 L 1866 1767.5 L 1863 1781.5 L 1853 1806.5 Q 1842.1 1826.1 1825.5 1840 Q 1812.1 1851.6 1794.5 1859 L 1779.5 1864 L 1763.5 1867 L 607 1867 L 607 1917.5 L 606 1918.5 L 605 1936.5 L 602 1948.5 Q 590.3 1983.3 564.5 2004 Q 550.8 2015.8 532.5 2023 L 516.5 2028 L 505.5 2030 L 496.5 2030 L 495.5 2031 L 111.5 2031 L 110.5 2030 L 101.5 2030 L 90.5 2028 L 69.5 2021 Q 48.2 2011.3 33 1995.5 Q 17.3 1979.7 8 1957.5 L 3 1941.5 L 1 1931.5 L 1 1922.5 L 0 1921.5 L 0 1137.5 L 1 1136.5 L 2 1121.5 L 5 1109.5 L 15 1086.5 Q 25.8 1068.3 41.5 1055 Q 63.2 1035.7 97.5 1029 Q 103 1030.5 104.5 1028 L 210 1028 L 210 718.5 L 211 717.5 L 211 708.5 L 214 693.5 L 223 670.5 Q 234.2 649.7 251.5 635 Q 264.9 623.4 282.5 616 L 307.5 609 L 327 608 L 327 578.5 L 328 577.5 L 329 566.5 L 334 550.5 Q 343.5 528.5 360.5 514 L 383.5 499 L 397.5 494 L 411.5 491 L 685.5 491 L 699.5 494 L 715.5 500 Q 733.4 509.1 746 523.5 Q 760.2 539.3 767 562.5 L 770 579.5 L 770 608 L 909.5 608 L 910 607.5 L 910 163.5 L 911 162.5 L 911 149.5 L 912 148.5 L 914 131.5 L 926 96.5 Q 941.8 64.3 967.5 42 Q 988.4 23.4 1016.5 12 L 1043.5 4 L 1054.5 3 L 1055.5 2 L 1063.5 2 L 1064.5 1 Z M 1075 70 L 1074 71 L 1059 72 L 1040 78 Q 1023 85 1011 97 Q 998 110 989 127 L 983 143 L 980 159 L 980 771 L 1587 771 L 1587 70 L 1075 70 Z M 1726 70 L 1725 71 L 1711 72 L 1702 75 L 1683 86 Q 1663 101 1657 131 L 1657 281 L 1797 281 L 1797 132 Q 1793 109 1781 96 Q 1770 82 1753 75 L 1739 71 L 1726 70 Z M 421 560 L 409 565 Q 400 571 397 582 L 397 1567 L 401 1576 Q 408 1585 422 1588 L 676 1588 L 689 1583 Q 697 1577 700 1567 L 700 582 L 696 573 Q 690 563 677 560 L 421 560 Z M 323 677 L 311 680 L 295 690 Q 283 700 280 718 L 280 1758 Q 283 1773 292 1783 Q 303 1795 323 1798 L 537 1798 L 537 1657 L 413 1657 L 389 1651 Q 372 1644 360 1633 Q 348 1623 340 1610 L 330 1586 L 327 1570 L 327 678 Q 327 677 323 677 Z M 770 677 L 770 1569 L 767 1586 L 762 1600 Q 755 1614 745 1626 Q 724 1650 685 1657 L 607 1657 L 607 1798 L 1755 1798 L 1767 1795 L 1782 1786 Q 1793 1776 1797 1758 L 1797 718 Q 1794 702 1785 693 Q 1774 680 1755 677 L 1657 677 L 1657 771 L 1727 771 L 1727 841 L 1727 841 L 840 841 L 840 771 L 910 771 L 910 677 L 770 677 Z M 114 1097 L 101 1100 L 86 1109 Q 74 1119 70 1137 L 70 1922 Q 72 1935 80 1944 Q 90 1957 111 1961 L 497 1961 Q 511 1958 521 1950 Q 531 1941 536 1926 L 537 1921 L 537 1867 L 314 1867 L 298 1864 L 283 1859 Q 265 1852 252 1840 Q 233 1824 221 1801 L 213 1778 L 211 1767 L 211 1758 L 210 1757 L 210 1098 L 210 1097 L 114 1097 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 957 934 L 1587 934 L 1587 1167 L 957 1167 L 957 934 Z M 1027 1004 L 1027 1098 L 1028 1098 L 1517 1098 L 1517 1005 L 1517 1004 L 1027 1004 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 957 1214 L 1120 1214 L 1120 1284 L 957 1284 L 957 1214 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 1190 1214 L 1353 1214 L 1353 1284 L 1190 1284 L 1190 1214 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 1424 1214 L 1587 1214 L 1587 1284 L 1424 1284 L 1424 1214 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 957 1354 L 1120 1354 L 1120 1424 L 957 1424 L 957 1354 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 1190 1354 L 1353 1354 L 1353 1424 L 1190 1424 L 1190 1354 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 1424 1354 L 1587 1354 L 1587 1424 L 1424 1424 L 1424 1354 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 957 1494 L 1120 1494 L 1120 1564 L 957 1564 L 957 1494 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 1190 1494 L 1353 1494 L 1353 1564 L 1190 1564 L 1190 1494 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 1424 1494 L 1587 1494 L 1587 1564 L 1424 1564 L 1424 1494 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 1190 1634 L 1353 1634 L 1353 1704 L 1190 1704 L 1190 1634 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'Fax')

export default icon
